/* eslint-disable default-case */
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  IconButton,
  LinearProgress,
  Menu,
  MenuItem,
  TextField,
  InputAdornment,
  Divider,
} from "@mui/material";
import {
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  InsertDriveFile as FileIcon,
  CloudUpload,
  Delete,
  CreateNewFolder,
  ArrowBack,
  Search,
  Upload,
  Download,
  DriveFolderUpload,
  ArrowCircleUp,
  Check,
} from "@mui/icons-material";
import { useDropzone } from "react-dropzone";

import { useLocation } from "react-router-dom";
import {
  deleteMutiFileFolder,
  fileDownloadStatusUpdate,
  filefolderGetFreelanceJobs,
  fileManagerPaste,
  fileManagerUpdate,
  getFileMangerList,
  getFilesCountForSingleScoop,
  getScoopFileFolders,
  Newfoldermake,
} from "../redux/Thunk/DashboardModule/DashboardThunk";
import { useDispatch, useSelector } from "react-redux";
import authApi from "../redux/authApi";
import FilePropertiesDialog from "./Ui_elements/FilePropertiesDialog";
import { Backdrop, CircularProgress } from "@mui/material";
import { formatDateTime } from "./formateDate";
import Loader from "./Ui_elements/Loader";
import { showSnackbar } from "../redux/Slice/snackbar/snackbarSlice";
import {
  downloadFolderAsZip,
  resolveFolderDownloadTarget,
  triggerPresignedDownload,
} from "../utils/folderDownload";

const CHUNK_SIZE = 5 * 1024 * 1024;
const CONCURRENCY = 5;
const CHUNK_RETRIES = 3;

const FileManager = () => {
  const dispatch = useDispatch();
  const { file_folders } = useSelector(state => state.root.DashboardModule);
  const { iFkUserTypeId } = useSelector(state => state?.root?.authUser?.user || {});
  const { loading } = useSelector(state => state.root.loading);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const scoopId = searchParams.get("scoopId");
  const jobId = searchParams.get("jobId");
  const sourceTargetType = searchParams.get("sourceTargetType");
  // const sourceTargetType =
  //   iFkUserTypeId === 2
  //     ? sourceTargetType_org === "_in"
  //       ? "_out"
  //       : sourceTargetType_org === "_out"
  //       ? "_in"
  //       : sourceTargetType_org
  //     : sourceTargetType_org;
  const jobTemplateId = searchParams.get("jobTemplateId");
  const clientId = searchParams.get("clientId");
  const inClientId = searchParams.get("inClientId");
  const userId = searchParams.get("userId");
  const jobParams = {
    jobId,
    sourceTargetType,
  };
  const [currentPath, setCurrentPath] = useState([]); // Tracks current path as array of IDs
  const [expandedFolders, setExpandedFolders] = useState(new Set()); // Tracks which folders are expanded
  const [files, setFiles] = useState([]); // For upload functionality
  const [fileStructure, setFileStructure] = useState([]); // The complete file structure
  const [currentItems, setCurrentItems] = useState([]); // Items in current view
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]); // Items selected with ctrl + click
  const [copiedIds, setCopiedIds] = useState([]); // Items copied
  const [isUploadOpen, setIsUploadOpen] = useState(true); // Items copied
  const abortRef = useRef({});

  const uploadingCount = files.filter(f => f.status === "uploading").length;
  const hasActiveUploads = uploadingCount > 0;
  const hasUploadSession = files.some(f => f.status === "queued" || f.status === "uploading");
  const showGlobalLoading = loading && !hasUploadSession;

  useEffect(() => {
    if (files.length === 0) return;
    const hasQueued = files.some(f => f.status === "queued");
    const hasUploading = files.some(f => f.status === "uploading");
    if (!hasQueued && !hasUploading) {
      setFiles([]);
    }
  }, [files]);

  const renderUploadStatus = entry => {
    switch (entry.status) {
      case "queued":
        return (
          <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
            Waiting...
          </Typography>
        );
      case "uploading":
        return (
          <Box
            sx={{
              width: 120,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              gap: 0.75,
            }}
          >
            <LinearProgress variant="determinate" value={entry.progress} sx={{ flex: 1 }} />
            <Typography variant="caption" color="text.secondary" sx={{ minWidth: 32, textAlign: "right" }}>
              {Math.round(entry.progress)}%
            </Typography>
          </Box>
        );
      case "completed":
        return <Check color="success" sx={{ fontSize: 20, flexShrink: 0 }} />;
      case "error":
        return (
          <Typography variant="caption" color="error" sx={{ flexShrink: 0 }}>
            Failed
          </Typography>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (!hasActiveUploads) return;

    const handler = e => {
      e.preventDefault();
      // Required for Chrome to show prompt; modern browsers may show a generic message.
      e.returnValue = "Files are still uploading. Leaving will cancel upload.";
      return e.returnValue;
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [hasActiveUploads]);

  useEffect(()=>{
if (window.opener && typeof window.opener.refreshFileManagerCount === "function") {
  window.opener.refreshFileManagerCount(); // call the main window function
}
  },[file_folders])

  const handleContextMenu = (e, item, isJobView = false) => {
    e.preventDefault();
    e.stopPropagation();
    setMenuAnchor({ mouseX: e.clientX + 2, mouseY: e.clientY - 6, item, isJobView });
    if (!selectedIds?.includes(item?.fmanager_id)) {
      handleItemSelection(e, item?.fmanager_id);
    }
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleFolderDownload = async (folderId, folderName = "TMS_", zipNameOverride) => {
    await downloadFolderAsZip({ folderId, folderName, zipNameOverride });
  };

  // Fast file download: request JSON from `/api/v1/downloadFileFast/{id}`.
  // Backend returns a presigned URL for the best large-file performance.
  // If the backend falls back to a binary stream, we still download safely.
  const handleFastDownload = async item => {
    const fmanagerId = item?.fmanager_id;
    const originalFilename = item?.original_filename;
    if (!fmanagerId) return;

    try {
      const apiBase = authApi?.defaults?.baseURL || "";
      const endpoint = `${apiBase.replace(/\/$/, "")}/downloadFileFast/${fmanagerId}`;

      const token = localStorage.getItem("token");
      const headers = { Accept: "application/json" };
      if (token) headers.Authorization = `Bearer ${token}`;

      const res = await fetch(endpoint, { method: "GET", headers });

      if (!res.ok) {
        let errMsg = `Download failed (HTTP ${res.status})`;
        try {
          const maybeJson = await res.json();
          errMsg = maybeJson?.msg || maybeJson?.error?.msg || errMsg;
        } catch (_) {}
        throw new Error(errMsg);
      }

      const contentType = (res.headers.get("content-type") || "").toLowerCase();

      const triggerBlobDownload = (blob, fileName) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName || "download");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(url), 10000);
      };

      // Presigned URL mode
      if (contentType.includes("application/json")) {
        const data = await res.json();
        if (data?.download_url) {
          const responseFileName = data?.file_name || originalFilename || "download";

          triggerPresignedDownload(data.download_url, responseFileName);

          dispatch(
            showSnackbar({
              message: data?.msg || "Download started",
              type: "success",
            })
          );
          return data;
        }
        throw new Error(data?.msg || "Invalid fast download response");
      }

      // Binary stream fallback (preserves filename)
      const blob = await res.blob();
      const contentDisposition = res.headers.get("content-disposition") || "";
      const match = contentDisposition.match(
        /filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i
      );
      const downloadName = match?.[1] || originalFilename || "download";
      triggerBlobDownload(blob, downloadName);

      dispatch(
        showSnackbar({
          message: "Download started",
          type: "success",
        })
      );
      return true;
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.message || "Download failed",
          type: "error",
        })
      );
      console.error("Fast download error:", error);
      throw error;
    }
  };

  const handleMenuAction = action => {
    switch (action) {
      case "open":
        handleFolderDoubleClick(menuAnchor?.item);
        break;
      case "delete":
        if (!selectedIds?.length) {
          window.alert("No files selected");
        } else if (window.confirm("Are you sure you want to delete this item?"))
          dispatch(deleteMutiFileFolder({ payload: selectedIds, scoopId })).then(() => {
            jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
            clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
            inClientId &&
              dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
            userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
            jobTemplateId &&
              dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
          });
        break;
      case "refresh":
        scoopId && dispatch(getScoopFileFolders(scoopId));
        jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
        clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
        inClientId && dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
        userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
        jobTemplateId &&
          dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));

        break;
      case "copy":
        setCopiedIds(selectedIds);
        break;
      case "copyFolder":
        setCopiedIds([menuAnchor?.item?.fmanager_id])
        break;
      case "paste":
        const payload = copiedIds?.map(s => ({ id: s, parent_id: currentPath?.at?.(-1) }));
        if (copiedIds?.length)
          dispatch(fileManagerPaste({ payload, scoopId })).then(() => {
            jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
            clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
            inClientId &&
              dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
            userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
            jobTemplateId &&
              dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
          });
        break;
      case "download":
        if (menuAnchor?.item?.categories) {
          const { folderId, folderName, zipNameOverride } = resolveFolderDownloadTarget(
            menuAnchor?.item
          );
          handleFolderDownload(folderId, folderName, zipNameOverride);
        } else {
          handleFastDownload(menuAnchor?.item).then(() => {
            iFkUserTypeId === 2 &&
              jobId &&
              dispatch(
                fileDownloadStatusUpdate({
                  fmanager_id: menuAnchor?.item?.fmanager_id,
                  jobId,
                })
              );
          });
        }
        break;
      case "rename":
        const newName = prompt(
          "Please enter name",
          menuAnchor?.item?.categories
            ? menuAnchor?.item?.name
            : menuAnchor?.item?.original_filename
        );
        if (newName)
          dispatch(
            fileManagerUpdate({
              id: menuAnchor?.item?.fmanager_id,
              payload: { name: newName }, //image: menuAnchor?.item?.name,
              scoopId,
            })
          ).then(() => {
            jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
            clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
            inClientId &&
              dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
            userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
            jobTemplateId &&
              dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
          });
    }
    handleCloseMenu();
  };

  const [jobs, setJobs] = useState([]);
  // Mock data - in a real app you would fetch this from an API
  useEffect(() => {
    jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
    clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
    inClientId && dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
    userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
    jobTemplateId && dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
    if (scoopId) {
      dispatch(getScoopFileFolders(scoopId));
      dispatch(filefolderGetFreelanceJobs(scoopId)).then(({ payload }) => {
        setJobs(payload.data);
      });
    }
  }, []);

  useEffect(() => {
    if (file_folders) {
      setFileStructure([file_folders]);
      handleFolderDoubleClick(file_folders);
      // Find the folder we're moving to
      let current = [file_folders];
      for (const id of currentPath) {
        const found = current.find(item => item.fmanager_id === id);
        if (found && found.categories) {
          current = found.categories;
        } else {
          break;
        }
      }
      setCurrentItems(current);
    }
  }, [file_folders, currentPath]);

  // handle ctrl + click item selection
  const handleItemSelection = (e, id) => {
    const isCtrlPressed = e.ctrlKey || e.metaKey; // Ctrl on Windows / Cmd on Mac

    setSelectedIds(prev => {
      if (isCtrlPressed) {
        // Toggle selection
        return prev.includes(id)
          ? prev.filter(x => x !== id) // unselect if already selected
          : [...prev, id]; // add to selection
      } else {
        // Single selection
        return [id];
      }
    });
  };
  // Handle folder click (single click - toggle expand)
  const handleFolderClick = (e, folderId) => {
    const isCtrlPressed = e.ctrlKey || e.metaKey; // Ctrl on Windows / Cmd on Mac
    // handleItemSelection(e, folderId);
    if (!isCtrlPressed)
      setTimeout(() => {
        setExpandedFolders(prev => {
          const newExpanded = new Set(prev);
          if (newExpanded.has(folderId)) {
            newExpanded.delete(folderId);
          } else {
            newExpanded.add(folderId);
          }
          return newExpanded;
        });
      }, 200);
  };

  function findPathByFmanagerId(node, targetId, path = []) {
    if (!node) return null;

    // Add current node's fmanager_id to the path
    const newPath = [...path, node.fmanager_id];

    if (node.fmanager_id === targetId) return newPath;

    // Recursively search children
    if (Array.isArray(node.categories)) {
      for (const child of node.categories) {
        const result = findPathByFmanagerId(child, targetId, newPath);
        if (result) return result;
      }
    }

    return null; // not found
  }
  // Handle folder double click (navigate into)
  const handleFolderDoubleClick = folder => {
    // const folder = jobId ? folder_org?.categories?.[0]: folder_org
    if (!currentPath.includes(folder.fmanager_id))
      setCurrentPath(findPathByFmanagerId(file_folders, folder?.fmanager_id));
    if (folder.categories && folder.categories.length > 0) {
      setCurrentItems(folder.categories);
    } else {
      setCurrentItems([]);
    }
    // Also expand this folder
    const newExpanded = new Set(expandedFolders);
    newExpanded.add(folder.fmanager_id);
    setExpandedFolders(newExpanded);
  };

  // Move up one level in directory
  const moveUpDirectory = () => {
    if (currentPath.length === 1) return;
    setExpandedFolders(new Set());
    const newPath = [...currentPath];
    newPath.pop();
    setCurrentPath(newPath);

    if (newPath.length === 0) {
      setCurrentItems(fileStructure);
    } else {
      // Find the folder we're moving to
      let current = fileStructure;
      for (const id of newPath) {
        const found = current.find(item => item.fmanager_id === id);
        if (found && found.categories) {
          current = found.categories;
        } else {
          break;
        }
      }
      setCurrentItems(current);
    }
  };

  // Render a folder with its contents
  const renderFolder = ({ item, depth = 1, isJobView = false }) => {
    const isExpanded = expandedFolders.has(item.fmanager_id);
    const hasChildren = item.categories && item.categories.length > 0;

    return (
      <React.Fragment key={item.fmanager_id}>
        <ListItem
          button
          onClick={e => handleFolderClick(e, item.fmanager_id)}
          onDoubleClick={() => !isJobView && handleFolderDoubleClick(item)}
          onContextMenu={e => handleContextMenu(e, item, isJobView)}
          sx={{
            pl: depth * 2,
            userSelect: "none",
            bgcolor: selectedIds.includes(item.fmanager_id) ? "grey.200" : "",
            "&:hover": {
              bgcolor: selectedIds.includes(item.fmanager_id) ? "grey.200" : "grey.100",
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: "40px" }}>
            {isExpanded ? <FolderOpenIcon color="primary" /> : <FolderIcon color="primary" />}
          </ListItemIcon>
          <ListItemText
            sx={{ overflowWrap: "anywhere" }}
            primary={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {item.name}{" "}
                <Typography
                  sx={{
                    bgcolor: "primary.light",
                    opacity: 0.6,
                    color: "#fff",
                    fontWeight: "500",
                    borderRadius: "20px",
                    padding: "0 5px",
                    minWidth: "16px",
                    lineHeight: "16px",
                    fontSize: "11px",
                    textAlign: "center",
                  }}
                >
                  {item?.countchild ?? item?.categories?.length ?? 0}
                </Typography>
              </Box>
            }
          />
        </ListItem>

        {hasChildren && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.categories.map(child =>
                child.categories
                  ? renderFolder({ item: child, depth: depth + 1, isJobView })
                  : renderFile({ item: child, depth: depth + 1, isJobView })
              )}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  // Render a file
  const renderFile = ({ item, depth = 1, isJobView = false }) => {
    return (
      <ListItem
        key={item.fmanager_id}
        sx={{
          pl: depth * 2,
          userSelect: "none",
          bgcolor: selectedIds.includes(item.fmanager_id) ? "grey.200" : "",
          "&:hover": { bgcolor: selectedIds.includes(item.fmanager_id) ? "grey.200" : "grey.100" },
        }}
        onClick={e => !isJobView && handleItemSelection(e, item?.fmanager_id)}
        onContextMenu={e => handleContextMenu(e, item, isJobView)}
        onDoubleClick={() =>
          handleFastDownload(item).then(() => {
            iFkUserTypeId === 2 &&
              jobId &&
              dispatch(
                fileDownloadStatusUpdate({
                  fmanager_id: item?.fmanager_id,
                  jobId,
                })
              );
          })
        }
      >
        <ListItemIcon sx={{ minWidth: "40px" }}>
          <FileIcon color="info" />
        </ListItemIcon>
        <ListItemText
          sx={{ overflowWrap: "anywhere" }}
          primary={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {item.original_filename || item.name}{" "}
              <Typography variant="caption" color="grey.700">
                ({item.size || "File"})
              </Typography>
              <IconButton
                onClick={() =>
                  handleFastDownload(item).then(() => {
                    iFkUserTypeId === 2 &&
                      jobId &&
                      dispatch(
                        fileDownloadStatusUpdate({
                          fmanager_id: item?.fmanager_id,
                          jobId,
                        })
                      );
                  })
                }
              >
                <Download sx={{ fontSize: "16px", color: "primary.main", cursor: "pointer" }} />
              </IconButton>
            </Box>
          }
          // secondary={` ${formatDateTime(item.created_date, true)}` || "File"}
          secondary={
            <>
              {formatDateTime(item.created_date, true)}
          
              {item?.last_downloaded_at && iFkUserTypeId !== 2 && (
                <>
                  {" • "}
                  Last Downloaded: {formatDateTime(item.last_downloaded_at, true)}
                </>
              )}
            </>
          }
        />
        {item?.is_download === 1 && iFkUserTypeId !== 2 && (
          <Box
            sx={{
              backgroundColor: theme => theme.palette.success.main,
              color: "#fff",
              borderRadius: "10px",
              height: "20px",
              width: "20px",
              textAlign: "center",
            }}
          >
            <Check
              sx={{
                fontSize: "12px",
              }}
            />
          </Box>
        )}
      </ListItem>
    );
  };

  // Dropzone functionality (same as your existing code)
  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop: useCallback(acceptedFiles => {
      const newEntries = acceptedFiles.map(file => ({
        file,
        progress: 0,
        status: "queued",
        upload: null,
      }));
      setFiles(curr => [...curr, ...newEntries]);
    }, []),
    noClick: true,
    noKeyboard: true,
    multiple: true,
  });

  const removeFile = idx => {
    if (abortRef.current[idx]) {
      abortRef.current[idx].abort();
    }
    setFiles(curr => curr.filter((_, i) => i !== idx));
  };

  const uploadChunkWithRetry = async (formData, onProgress, signal) => {
    for (let attempt = 1; attempt <= CHUNK_RETRIES; attempt++) {
      try {
        await authApi.post("/saveFileUploadFastChunk", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: onProgress,
          signal,
        });
        return;
      } catch (err) {
        if (err.name === "CanceledError" || err.name === "AbortError") throw err;
        if (attempt === CHUNK_RETRIES) throw err;
      }
    }
  };

  const uploadAll = () => {
    files.forEach((entry, idx) => {
      if (entry.status !== "queued") return;

      setFiles(curr =>
        curr.map((f, i) => (i === idx ? { ...f, status: "uploading", progress: 0 } : f))
      );

      const file = entry.file;
      const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
      const uploadId = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
      const chunkLoaded = {};

      const updateProgress = () => {
        const loaded = Object.values(chunkLoaded).reduce((a, b) => a + b, 0);
        const pct = file.size > 0 ? Math.min(99, (loaded / file.size) * 100) : 0;
        setFiles(curr => curr.map((f, i) => (i === idx ? { ...f, progress: pct } : f)));
      };

      const ac = new AbortController();
      abortRef.current[idx] = ac;

      (async () => {
        try {
          let nextChunkIndex = 0;

          const runNext = async () => {
            while (!ac.signal.aborted) {
              const chunkIndex = nextChunkIndex++;
              if (chunkIndex >= totalChunks) break;

              const start = chunkIndex * CHUNK_SIZE;
              const end = Math.min(start + CHUNK_SIZE, file.size);
              const blob = file.slice(start, end);

              const formData = new FormData();
              formData.append("chunk", blob);
              formData.append("uploadId", uploadId);
              formData.append("chunkIndex", String(chunkIndex));
              formData.append("totalChunks", String(totalChunks));
              formData.append("original_filename", file.name);

              await uploadChunkWithRetry(
                formData,
                e => {
                  if (e.lengthComputable) {
                    chunkLoaded[chunkIndex] = e.loaded;
                    updateProgress();
                  }
                },
                ac.signal
              );
            }
          };

          await Promise.all(Array.from({ length: CONCURRENCY }, () => runNext()));
          if (ac.signal.aborted) return;

          const completePayload = {
            uploadId,
            totalChunks,
            mode: "save_db",
            role_id: iFkUserTypeId,
            f_id: "1",
            parent_id: currentPath?.at(-1) ?? file_folders?.fmanager_id ?? null,
            f_scoop_id: scoopId || 0,
            job_id: jobId || 0,
            original_filename: file.name,
            ext: file.name.split(".").pop() || "",
            size: file.size,
          };

          await authApi.post("/saveFileUploadFastComplete", completePayload, {
            headers: { "Content-Type": "application/json" },
            signal: ac.signal,
          });

          setFiles(curr =>
            curr.map((f, i) => (i === idx ? { ...f, status: "completed", progress: 100 } : f))
          );

          scoopId && dispatch(getScoopFileFolders(scoopId));
          scoopId && localStorage.setItem("refreshFileCountsForScoop", Date.now().toString());
          jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
          jobId && localStorage.setItem("refreshFileCounts", Date.now().toString());
          clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
          inClientId && dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
          userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
          jobTemplateId &&
            dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
        } catch (err) {
          if (err.name === "CanceledError" || err.name === "AbortError") return;
          console.error("Upload error:", err);
          setFiles(curr => curr.map((f, i) => (i === idx ? { ...f, status: "error" } : f)));
        } finally {
          delete abortRef.current[idx];
        }
      })();
    });
  };
  const handleCreateNewFolder = () => {
    const payload = {
      scoopId,
      parentId: currentPath?.at?.(-1),
      title: prompt("Please enter folder name"),
    };
    if (payload.title)
      dispatch(Newfoldermake(payload)).then(() => {
        jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
        clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
        inClientId && dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
        userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
        jobTemplateId &&
          dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
      });
  };
  function searchNodes(node, searchText, results = []) {
    if (!node) return results;

    const text = searchText.toLowerCase();

    // Check current node
    if ((node.original_filename || node.name).toLowerCase().includes(text)) {
      results.push(node);
    }

    // Recurse into children if any
    if (Array.isArray(node.categories)) {
      for (const child of node.categories) {
        searchNodes(child, searchText, results);
      }
    }

    return results;
  }
  const handleSearch = e => {
    setExpandedFolders(new Set());
    if (e.target.value?.trim()) {
      const modifiedNode = { ...file_folders };
      modifiedNode.name = "";
      // if(jobId) modifiedNode.categories[0].name = ''
      setCurrentItems(searchNodes(modifiedNode, e.target.value));
    } else {
      handleFolderDoubleClick(file_folders);
    }
  };
  return (
    <Box sx={{ py: 2, px: 8 }}>
      <Typography variant="h6" gutterBottom>
        File Manager: {file_folders?.fileManager_title}
      </Typography>
      {!scoopId && !jobId && !jobTemplateId && !userId && !inClientId && !clientId ? (
        <Typography variant="h6" sx={{ textAlign: "center", mt: 3 }} color="textDisabled">
          No data found
        </Typography>
      ) : (
        (!loading || hasUploadSession) && (
          <Box sx={{ p: 2 }} className="whiteBackground">
            <Box
              sx={{ mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box>
                <IconButton
                  onClick={moveUpDirectory}
                  disabled={currentPath.length === 1}
                  title="Level up"
                >
                  <DriveFolderUpload />
                </IconButton>
                {(!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === '_in')) && (<>
                  <IconButton onClick={() => setIsUploadOpen(p => !p)} title="Upload">
                    <ArrowCircleUp />
                  </IconButton>
                  <IconButton
                    aria-label="Create new folder"
                    onClick={handleCreateNewFolder}
                    title="Create folder"
                  >
                    <CreateNewFolder />
                  </IconButton>
                  <IconButton onClick={() => handleMenuAction("delete")} title="Delete">
                    <Delete />
                  </IconButton>
                </>)}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography>Selected files: {selectedIds?.length}</Typography>
                <Button onClick={() => setSelectedIds([])}>Clear</Button>
                <TextField
                  onChange={handleSearch}
                  placeholder="Search"
                  sx={{ width: "25ch" }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="end">
                          <Search />
                        </InputAdornment>
                      ),
                    },
                  }}
                  variant="outlined"
                />
              </Box>
            </Box>
            {(!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === '_in')) && isUploadOpen && (
              <Box
                variant="outlined"
                {...getRootProps()}
                sx={{
                  p: 4,
                  border: "2px dashed",
                  borderColor: "grey.700",
                  textAlign: "center",
                  borderRadius: 4,
                  cursor: "pointer",
                  "&:hover": { bgcolor: "action.hover", borderColor: "primary.light" },
                }}
                className="whiteBackground"
              >
                <input {...getInputProps()} />
                <CloudUpload onClick={open} fontSize="large" color="action" />
                <Typography>Drag & drop files here</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  or <br /> <Button onClick={open}>Select Files</Button>
                </Typography>
              </Box>
            )}
            <Box sx={{ mb: 2 }}>
              {files.length > 0 && (
                <>
                  <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 1 }}>
                    <Button
                      variant="contained"
                      onClick={uploadAll}
                      disabled={files.every(f => f.status !== "queued")}
                    >
                      <Upload /> Upload
                    </Button>
                  </Box>

                  <List dense sx={{ mt: 1 }}>
                    {files.map((entry, idx) => (
                      <ListItem
                        key={idx}
                        dense
                        sx={{ gap: 1, py: 0.5, pr: 1 }}
                      >
                        <ListItemText
                          primary={entry.file.name}
                          primaryTypographyProps={{ noWrap: true }}
                          sx={{ flex: 1, minWidth: 0, m: 0 }}
                        />
                        {renderUploadStatus(entry)}
                        <IconButton size="small" edge="end" onClick={() => removeFile(idx)} aria-label="Remove file">
                          <Delete fontSize="small" />
                        </IconButton>
                      </ListItem>
                    ))}
                  </List>
                </>
              )}
            </Box>

            <Box variant="outlined" sx={{ mb: 2 }} className="whiteBackground">
              <List
                onContextMenu={e => {
                  e.preventDefault();
                  setMenuAnchor({
                    mouseX: e.clientX + 2,
                    mouseY: e.clientY - 6,
                    item: { fmanager_id: currentItems?.at?.(0), isPastable: true },
                  });
                }}
                sx={{ paddingBottom: "100px" }}
              >
                {currentItems?.[0]?.fmanager_id ? (
                  currentItems?.map(item =>
                    item.categories ? renderFolder({ item }) : renderFile({ item })
                  )
                ) : (
                  <Typography
                    color="textDisabled"
                    sx={{ textAlign: "center", p: 3, fontWeight: 500 }}
                  >
                    No items to show
                  </Typography>
                )}
              </List>
              {currentPath?.length <= 1 && scoopId && (
                <>
                  <Divider />

                  <Typography variant="h5" p={2}>
                    Linguist Delivery
                  </Typography>
                  <List sx={{ paddingBottom: "100px" }}>
                    {jobs?.length ? (
                      jobs?.map(item =>
                        item.categories
                          ? renderFolder({ item, isJobView: true })
                          : renderFile({ item, isJobView: true })
                      )
                    ) : (
                      <Typography
                        color="textDisabled"
                        sx={{ textAlign: "center", p: 3, fontWeight: 500 }}
                      >
                        No items to show
                      </Typography>
                    )}
                  </List>
                </>
              )}

              <Menu
                open={menuAnchor !== null}
                onClose={handleCloseMenu}
                anchorReference="anchorPosition"
                anchorPosition={
                  menuAnchor !== null
                    ? { top: menuAnchor.mouseY, left: menuAnchor.mouseX }
                    : undefined
                }
              >
                {!menuAnchor?.isJobView ? (
                  menuAnchor?.item?.isPastable ? (
                    <>
                      {!clientId && !userId && !inClientId && (
                        <MenuItem
                          onClick={() => handleMenuAction("paste")}
                          disabled={!copiedIds?.length}
                        >
                          Paste
                        </MenuItem>
                      )}
                      {!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === '_in') && (
                        <MenuItem onClick={handleCreateNewFolder}>New folder</MenuItem>
                      )}
                      <MenuItem onClick={() => handleMenuAction("refresh")}>Refresh</MenuItem>
                    </>
                  ) : (
                    <>
                      {menuAnchor?.item?.categories ? (
                        <>
                          <MenuItem onClick={() => handleMenuAction("open")}>Open</MenuItem>
                          {!clientId && !userId && !inClientId && (
                            <MenuItem onClick={() => handleMenuAction("rename")}>Rename</MenuItem>
                          )}
                          {!clientId && !userId && !inClientId && (!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === '_in')) && (
                            <MenuItem onClick={() => handleMenuAction("copyFolder")}>Copy</MenuItem>
                          )}
                        </>
                      ) : (
                        <>
                          {jobId && (
                            <MenuItem onClick={() => handleMenuAction("rename")}>Rename</MenuItem>
                          )}
                          {(!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === '_in')) && !clientId && !userId && !inClientId && (
                            <MenuItem onClick={() => handleMenuAction("copy")}>Copy</MenuItem>
                          )}
                          <MenuItem>
                            <FilePropertiesDialog item={menuAnchor?.item} />
                          </MenuItem>
                        </>
                      )}
                      <MenuItem onClick={() => handleMenuAction("download")}>Download</MenuItem>
                      {!clientId && !userId && !inClientId && (!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === '_in')) && (
                        <MenuItem onClick={() => handleMenuAction("delete")}>Delete</MenuItem>
                      )}
                    </>
                  )
                ) : (
                  <>
                    {menuAnchor?.item?.categories ? (
                      <MenuItem onClick={() => handleMenuAction("download")}>
                        Download Folder as ZIP
                      </MenuItem>
                    ) : (
                      <MenuItem onClick={() => handleMenuAction("download")}>Download</MenuItem>
                    )}
                  </>
                )}
              </Menu>
            </Box>
          </Box>
        )
      )}

      <Backdrop sx={theme => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })} open={showGlobalLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default FileManager;
